<div class="container-fluid p-4 d-flex flex-column flex-grow-1 overflow-hidden">
  <app-side-modal />
  @if (warnings().length > 0) {
    <div class="row">
      <div class="col">
        @for (warning of warnings(); track warning) {
          <div class="alert alert-warning py-2 mb-2" role="alert">{{ warning }}</div>
        }
      </div>
    </div>
  }
  <div class="row" [class.mb-3]="schedulingMode()">
    <div class="col">
      @if (schedulingMode()) {
        <!--
          MOD-3651: the panel owns its foreman list and per-row availability — fetched
          against opportunity.job.branchId (the project's branch), not the calendar's
          selection. The local panelForemanOptions signal (computed above) is retained
          ONLY for displayCrewGroups()'s grid decoration; nothing flows into the panel.
          -->
        <app-schedule-project-panel
          [opportunityId]="panelOpportunityId()"
          [projectId]="panelProjectId()"
          [branchId]="panelBranchId()"
          [initialInstallDates]="panelInstallDates()"
          [customerSatisfactionVisit]="customerSatisfactionVisit"
          [crewsLoading]="isLoading()"
          (saved)="onPanelSaved()"
          (exitEditMode)="onPanelExitEditMode()"
          (goBackToJob)="onPanelGoBackToJob()"
          (dateRemoved)="onPanelDateRemoved($event)"
          (projectChanged)="onPanelProjectChanged($event)"
        />
      }
      <app-weekly-calendar-metrics
        [selectedBranch]="selectedBranch()"
        [startDate]="startDate()"
        [paused]="schedulingMode()"
        [hidden]="schedulingMode()"
      />
    </div>
  </div>
  <div class="row flex-grow-1">
    <div class="col d-flex flex-column">
      <groundworks-legend [items]="legendItems()" />
      <groundworks-production-calendar
        [crewGroups]="displayCrewGroups()"
        [isLoading]="isLoading()"
        [isError]="isError()"
        [canEdit]="canEdit"
        [startDate]="initialDate"
        [scrollToCrewGroupId]="scrollToCrewGroupId()"
        [capabilityDisplay]="'canInstall'"
        [sectionOrder]="sectionOrder"
        [earliestInstallDate]="today"
        (settingsClicked)="onSettings()"
        (selectionChanged)="onWeekChanged($event)"
        (eventClicked)="onEventClicked($event)"
        (eventActionClicked)="onEventActionClicked($event)"
        (addClicked)="onAddClicked($event)"
        (removeClicked)="onRemoveClicked($event)"
        (nameClicked)="onNameClicked($event)"
        [schedulingMode]="schedulingMode()"
        (scheduleClicked)="onScheduleProject($event)"
        (calendarViewChange)="onCalendarViewChanged($event)"
      />
    </div>
  </div>
</div>
